import { render } from "./WhatsApp.vue?vue&type=template&id=c8eda692"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"

import "./WhatsApp.vue?vue&type=style&index=0&id=c8eda692&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__